<template>
  <div class="full-loading">
    <div class="logo">
      <a id="logo" :style="`background-image: url('/img/logo-conicle-red.png')`"/>
    </div>
    <CncLoading size="small"/>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.full-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  flex-direction: column;
  gap: 20px;

  .logo {
    position: relative;
    width: 220px;

    #logo {
      display: inline-block;
      width: 100%;
      height: 60px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
}
</style>
